// components/Login.js
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../context/redux/slicers/authSlice';
import { LayoutLogin } from '../layouts/LoginLayout';
import { Alert, Avatar, Box, Button, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useFormik } from 'formik';
import * as Yup from 'yup';

//Rol Administrador
const initialValues = {
  email: '',
  password: ''
};

//Rol Administrador
// const initialValues = {
//   email: 'eduardo.carbajal@hidalgo.gob.mx',
//   password: '123'
// };

// Rol Operador
// const initialValues = {
//   email: 'partida.material.oficina@hidalgo.gob.mx',
//   password: 'Of1c1n4*2024',   
// };

const LoginPage = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      email: Yup.string().required('Campo requerido'),
      password: Yup.string().required('Campo requerido'),
    }),
    onSubmit: (values) => {
      dispatch(login(values));
    },
  });

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: 'primary.black',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 4,
          py: 4,
          maxWidth: '400px',
          backgroundColor: 'primary.white',
          borderRadius: 5,
        }}
      >
        <Avatar
          sx={{
            bgcolor: 'transparent',
          }}
        >
          <Box
            component="img"
            sx={{
              backgroundImage: 'url(/assets/Estrella_100.png)',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              aspectRatio: '1/1',
              width: '100%',
            }}
          />
        </Avatar>
        <Typography
          variant="h4"
          color='primary.black'
          fontWeight={500}
        >
          Bienvenido
        </Typography>
        <Typography
          variant="subtitle1"
          color='primary.black'
          fontWeight={300}
        >
          Ingresa tu usuario y contraseña
        </Typography>
        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          noValidate
          sx={{
            mt: 1,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo Electrónico"
            name="email"
            autoComplete="email"
            value={formik.values.email}
            onChange={formik.handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Contraseña"
            type={showPassword ? 'text' : 'password'}
            id="password"
            autoComplete="current-password"
            value={formik.values.password}
            onChange={formik.handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={handleClickShowPassword}
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
              mt: 3,
              mb: 2,
              width: '100px',
              borderRadius: 10,
            }}
          >
            Entrar
          </Button>
        </Box>

        {error && <Alert severity="error">{error}</Alert>}
      </Box>

      {/* <Button
        variant="outlined"
        sx={{
          borderRadius: 10,
          mt: 4,
        }}
        onClick={() => window.location.href = '/'}
      >
        Ir a la página principal
      </Button> */}
    </div>
  );
};

const Login = () => {
  return (
    <LayoutLogin>
      <LoginPage />
    </LayoutLogin>
  );
}

export default Login;
